/**
 * Controller for the Preload Indicator component.
 * Displays a subtle spinner in the bottom-right corner during preload.
 */
export default class PreloadIndicatorController {
    static $inject = ['$scope', 'PreloadBridgeService'];

    constructor($scope, PreloadBridgeService) {
        this.$scope = $scope;
        this.preloadBridge = PreloadBridgeService;

        // State
        this.visible = false;
        this.state = 'idle';
        this.progress = 0;
        this.currentBundle = '';
        this.tooltipText = '';

        // Bind methods
        this.handleStatusUpdate = this.handleStatusUpdate.bind(this);

        // Initialize
        this.init();
    }

    /**
     * Initialize the controller
     */
    init() {
        // Subscribe to status updates
        this.preloadBridge.onStatusUpdate(this.handleStatusUpdate);

        // Cleanup on scope destroy
        this.$scope.$on('$destroy', () => {
            this.preloadBridge.offStatusUpdate(this.handleStatusUpdate);
        });
    }

    /**
     * Handle status update from service worker
     */
    handleStatusUpdate(status) {
        // Use $applyAsync to avoid digest-in-progress errors
        this.$scope.$applyAsync(() => {
            this.state = status.state;
            this.progress = status.progress || 0;
            this.currentBundle = status.currentBundle || '';

            // Determine visibility
            this.visible = status.state === 'downloading' || status.state === 'checking';

            // Update tooltip text
            this.updateTooltipText(status);
        });
    }

    /**
     * Update the tooltip text based on current status
     */
    updateTooltipText(status) {
        switch (status.state) {
            case 'checking':
                this.tooltipText = 'Checking for updates...';
                break;
            case 'downloading':
                if (status.currentBundle) {
                    const bundleName = this.formatBundleName(status.currentBundle);
                    if (status.progress !== undefined) {
                        this.tooltipText = `Downloading ${bundleName}... ${status.progress}%`;
                    } else {
                        this.tooltipText = `Downloading ${bundleName}...`;
                    }
                } else {
                    this.tooltipText = 'Preparing offline mode...';
                }
                break;
            case 'ready':
                this.tooltipText = 'Offline mode ready';
                break;
            case 'error':
                this.tooltipText = 'Offline preparation failed';
                break;
            default:
                this.tooltipText = '';
        }
    }

    /**
     * Format bundle name for display
     */
    formatBundleName(bundleName) {
        switch (bundleName) {
            case 'core':
                return 'app resources';
            case 'geogebra':
                return 'GeoGebra tools';
            case 'desmos':
                return 'Desmos calculator';
            default:
                return bundleName;
        }
    }
}
